
export const solutions = {
  '1gb.solutions': '1Gb解决方案',
  '10gb.solutions': '10Gb解决方案',
  '1gb.vpx.accessories': '1Gb VPX配件',
  'software': '软件',
  '1gb.description': '高性能1Gb AV over IP解决方案',
  '10gb.description': '超高性能10Gb AV over IP解决方案',
  'vpx.accessories.description': '1Gb VPX解决方案的必备配件',
  'software.description': 'Aurora的IPBaseT Manager软件是Aurora IPBaseT AV over IP产品的IPX，VPX和VLX系列的多合一控制应用程序',
  'avoip.solutions': 'AVOIP解决方案',
  'choose.network.speed': '选择您喜欢的网络速度',
  'touch.controllers': '触摸控制器',
  'touch.controllers.description': '用于无缝控制的专业触摸面板界面',
  'control.processors': '控制处理器',
  'control.processors.description': '用于系统管理的高级控制处理器',
  'reax.software': '软件',
  'reax.software.description': '专业控制系统开发软件',
  'reax.accessories': '配件',
  'reax.accessories.description': 'ReAX系统的基本配件',
  'reax.control.solutions': 'ReAX控制解决方案',
  'choose.control.solution': '选择您喜欢的控制解决方案',
  'digital.signal.processors': '数字信号处理器',
  'dsps.description': '专业音频处理解决方案',
  'amplifiers': '放大器',
  'amplifiers.description': '高性能音频放大',
  'speakers': '扬声器',
  'speakers.description': '优质音频再现解决方案',
  'audio.solutions': '音频解决方案',
  'choose.audio.solution': '选择您喜欢的音频解决方案',
};
